var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(!['APPROVED', 'FLAGGED'].includes(_vm.willStatus))?[_vm._v("\n    is\n  ")]:_vm._e(),_vm._v(" "),_c('Tooltip',{class:{ '--theme-color --error': _vm.willStatus === 'FLAGGED' },attrs:{"content":_vm.tooltip}},[_c('DecoratedText',[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }